import api from "@/modules/global/lib/api-client.js";
import cloneDeep from "lodash/cloneDeep";
import loadash from "lodash";
import threadNames from "@/utils/thread-names.js";

const defaultState = {
  locales: [],
  activeFilterParams: {
    project: null,
    projectName: null,
    projectIndex: null,
    assessmentType: null,
    thread: null,
    threadId: null,
    school: null,
    schoolFetched: null,
    engagementsFetched: null,
    improvementsFetched: null,
    grade: null,
    class: null,
    tutor: null,
    time: "month",
    isMatricAssessment: null,
    country: null,
    currentSubject: "MATHS"
  },
  filterLists: {
    threads: {
      filterBy: true,
      value: {
        normal: [
          "Numbers",
          "Fractions",
          "Measurement",
          "Data Literacy",
          "Problem Solving",
          "Patterns & Algebra",
          "Space & Shape"
        ],
        matric: ["Numbers", "Fractions", "Patterns & Algebra", "Space & Shape"]
      }
    },
    schools: {
      filterBy: null,
      value: null
    },
    tutors: {
      filterBy: null,
      value: null
    }
  },
  tempLoadLearners: [],
  tempUserData: [],
  currentSchoolIndex: 0,
  currentGradeIndex: 0,
  currentSchoolName: null,
  projects: [],
  usersRawData: [],
  reflectiveData: [],
  activeUser: null,
  settings: {
    learnerButtonActive: 0,
    isProject: null,
    isInternal: false,
    isSuperAdmin: null,
    isReadOnly: null,
    screenLoading: null,
    isLearnerModalActive: false,
    isViewAllModalActive: false,
    isResultsBreakdownModalActive: false,
    printing: false,
    projectPermissions: null,
    isAsideVisible: true,
    isFooterBarVisible: true,
    isNavBarVisible: true,
    isAsideMobileExpanded: false
  },
  hasFetchedImprovements: false,
  hasFetchedEngagements: false
};

export default {
  namespaced: true,
  state: cloneDeep(defaultState),
  getters: {
    getUsersRawData: state => {
      return state.usersRawData;
    },
    isInternal: state => {
      return state.settings.isInternal;
    },
    getChangeUserData: state => {
      return state.tempUserData;
    },
    getCurrentSchoolIndex: state => {
      return state.currentSchoolIndex;
    },
    getCurrentGradeIndex: state => {
      return state.currentGradeIndex;
    },
    getSchoolName: state => {
      return state.currentSchoolName;
    },
    getChangedLearnersData: state => {
      return state.reflectiveData;
    },
    getFilteredList: state => {
      let userData = state.reflectiveData;
      let counter = 1;

      // filter by assessmentType
      // if (state.activeFilterParams.assessmentType) {
      //   userData = state.reflectiveData.filter(user => {
      //     // console.log('user.assessmentStates.length', user.assessmentStates.length);
      //     // console.log(user.email, user.assessmentStates[0].type === state.activeFilterParams.assessmentType);
      //     // counter++;
      //     // console.log(counter);
      //     return (
      //       user.assessmentStates &&
      //       user.assessmentStates.length > 0 &&
      //       user.assessmentStates[0].type ===
      //         state.activeFilterParams.assessmentType
      //     );
      //   });
      // }

      // filter by school
      if (state.activeFilterParams.project && state.settings.isProject) {
        userData = userData.filter(user => {
          // console.log(user.email, user.project === state.activeFilterParams.project);
          return user.project === state.activeFilterParams.project;
        });
      }
      if (
        state.filterLists.schools.value &&
        state.filterLists.schools.value.length > 1 &&
        state.activeFilterParams.school
      ) {
        userData = userData.filter(user => {
          // console.log(user.email + ' - school', user.school === state.activeFilterParams.school);
          return user.school === state.activeFilterParams.school;
        });
      }
      // changes to be made here
      if (state.activeFilterParams.grade) {
        userData = userData.filter(user => {
          /*
              The code will be modified to retrieve the school grade from the learner's object instead of using the grade directly.
          */
          // return user.schoolGrade == state.activeFilterParams.grade;
          return user.grade == state.activeFilterParams.grade;
        });
      }

      if (state.activeFilterParams.class) {
        userData = userData.filter(user => {
          // console.log(user.email + ' - class', user.class == state.activeFilterParams.class);
          return user.class == state.activeFilterParams.class;
        });
      }

      if (
        state.activeFilterParams.tutor &&
        state.filterLists.tutors.value.length > 0
      ) {
        userData = userData.filter(user => {
          return state.activeFilterParams.tutor.learners.includes(user._id);
        });
      }

      return userData;
    },
    // hasFetchedImprovements: state => {
    //   return state.activeFilterParams.improvementsFetched;
    // },
    fetchedImprovements: state => {
      return state.hasFetchedImprovements;
    },
    getCurrentSubject: state => {
      if (state.activeFilterParams.currentSubject) {
        return state.activeFilterParams.currentSubject;
      }
      return defaultState.activeFilterParams.currentSubject;
    }
  },
  mutations: {
    setLocales(state, locales) {
      state.locales = locales;
    },
    updateIsInternal(state, val) {
      state.settings.isInternal = val;
    },
    resetState(state) {
      const s = cloneDeep(defaultState);

      // Object.keys(s).forEach(key => {
      //   state[key] = s[key];
      // });
      state["projects"] = s["projects"];
    },
    updateProject(state, val) {
      state.activeFilterParams.project = val;
    },
    updateProjectName(state, val) {
      state.activeFilterParams.projectName = val;
    },
    updateCountry(state, val) {
      state.activeFilterParams.country = val;
    },
    updateIsMatricAssessment(state, val) {
      state.activeFilterParams.isMatricAssessment = val;
    },
    updateAssessmentType(state, val) {
      state.activeFilterParams.assessmentType = val;
    },
    updateThread(state, val) {
      state.activeFilterParams.thread = val;
    },
    updateThreadId(state, val) {
      state.activeFilterParams.threadId = val;
    },
    updateSchool(state, val) {
      state.activeFilterParams.school = val;
    },
    updateSchoolFectched(state, val) {
      state.activeFilterParams.schoolFetched = val;
    },
    updateEngagementsFetched(state, val) {
      state.activeFilterParams.engagementsFetched = val;
    },
    updateImprovementsFetched(state, val) {
      state.activeFilterParams.improvementsFetched = val;
    },
    updateGrade(state, val) {
      state.activeFilterParams.grade = val;
    },
    updateLearnersTable(state, updatedUser) {
      //Update Learners Table
      // let tempUser = state.reflectiveData.find(user => user._id === updatedUser._id);
      // Object.keys(updatedUser).forEach(key => {
      //   tempUser[key] = updatedUser[key];
      // });
      let userIndex = state.reflectiveData.findIndex(user => user._id === updatedUser._id);

      state.reflectiveData[userIndex] = updatedUser;

      let updatedUserIndexInRawData = state.usersRawData.findIndex(user => user._id === updatedUser._id);

      state.usersRawData[updatedUserIndexInRawData]  = {
        _id: updatedUser._id,
        email: updatedUser.email,
        catchupStates: updatedUser.catchupStates,
        assessmentStates: updatedUser.assessmentStates
      };
    },
    changeUserdata(state, learners) {
      //more logic needed.
      learners.forEach(userEmail => {
        state.tempUserData.push(userEmail);
      });
      // state.tempUserData = learners;
    },
    setSchoolIndex(state, school) {
      state.currentSchoolIndex = school;
    },
    setGradeIndex(state, grade) {
      state.currentGradeIndex = grade;
    },
    setCurrentSchoolName(state, schoolName) {
      state.currentSchoolName = schoolName;
    },
    updateClass(state, val) {
      state.activeFilterParams.class = val;
    },
    updateTime(state, val) {
      state.activeFilterParams.time = val;
    },
    updateTutor(state, val) {
      state.activeFilterParams.tutor = val;
    },
    updateActiveUser(state, val) {
      state.activeUser = val;
    },
    updateActiveButton(state, val = 0) {
      state.settings.learnerButtonActive = val;
    },
    updateIsLearnerModalActive(state, val) {
      state.settings.isLearnerModalActive = val;
    },
    updateIsViewAllModalActive(state, val) {
      state.settings.isViewAllModalActive = val;
    },
    updateResultsBreackdownModalActive(state, val) {
      state.settings.isResultsBreakdownModalActive = val;
    },
    loadUsers(state, learnersArray) {
      state.reflectiveData = [];
      state.reflectiveData.push(...learnersArray);
    },
    loadUsersRawData(state, learnersArray) {
      state.usersRawData = learnersArray;
    },
    addUsers(state, learnersArray) {
      state.reflectiveData.push(...learnersArray);
    },
    updateProjectsArray(state, project) {
      state.projects.push(project);
      state.projects.sort((a, b) => (a.project > b.project ? 1 : -1));
    },
    updateSchoolFlag(state, val) {
      state.filterLists.schools.value[val.index].fetched = val.flag;
    },
    setFilterValues(state) {
      let index = state.projects.findIndex(
        project => project.project === state.activeFilterParams.project
      );
      if (state.settings.isProject) {
        if (index > -1) {
          state.filterLists.schools.filterBy = true;
          state.filterLists.schools.value = state.projects[index].schools;
        }
      } else {
        if (index > -1) {
          state.filterLists.tutors.filterBy = true;
          state.filterLists.tutors.value = state.projects[index].tutors;
        }
      }
    },
    setIsProject(state, val) {
      state.settings.isProject = val;
    },
    setFetchedDataValue(state, params) {
      let index = state.projects.findIndex(
        proj => proj.project === params.project
      );
      state.projects[index].schools[params.schoolIndex].fetched = true;
      state.filterLists.schools.value[params.schoolIndex].fetched = true;
    },
    setFetchedImprovementsValue(state, params) {
      let index = state.projects.findIndex(
        proj => proj.project === params.filter.project
      );
      state.projects[index].schools[
        params.schoolIndex
      ].improvementsFetched = true;
      state.filterLists.schools.value[
        params.schoolIndex
      ].improvementsFetched = true;
    },
    setFetchedEngagementsValue(state, params) {
      let index = state.projects.findIndex(
        proj => proj.project === params.filter.project
      );
      state.projects[index].schools[
        params.schoolIndex
      ].engagementsFetched = true;
      state.filterLists.schools.value[
        params.schoolIndex
      ].engagementsFetched = true;
    },
    setImprovementResults(state, results) {
      results.forEach(result => {
        let learner = state.reflectiveData.find(
          learner => learner._id == result._id.userId
        );
        if (learner) {
          if (!learner.improvement) {
            learner.improvement = {};
          }
          if (!learner.improvement[result._id.subject]) {
            learner.improvement[result._id.subject] = [];
          }
          learner.improvement[result._id.subject][result._id.threadId] =
            result.finals;
        }
      });
    },
    setEngagementResults(state, results) {
      results.forEach(result => {
        let learner = state.reflectiveData.find(
          learner => learner._id == result._id
        );
        if (learner && !learner.engagement) {
          learner.engagement = {
            total: result.tot,
            dates: result.days,
            lastSeen: result.lastSeen
          };
        }
      });
    },
    setHasFetchedImprovements(state, val) {
      state.hasFetchedImprovements = val;
    },
    setActiveProjectEngagementsFlag(state, val) {
      if (state.projects[val.index]) {
        state.projects[val.index].engagementsFlag = val.value;
      }
    },
    setActiveProjectImprovementsFlag(state, val) {
      if (state.projects[val.index]) {
        state.projects[val.index].improvementsFlag = val.value;
      }
    },
    updateGradeThreads(state) {
      let currentThreads = [];
      if (threadNames[state.activeFilterParams.assessmentType]) {
        Object.keys(
          threadNames[state.activeFilterParams.assessmentType]
        ).forEach(key => {
          currentThreads.push(
            threadNames[state.activeFilterParams.assessmentType][key]
          );
        });
      }
      if (!currentThreads.length) {
        // eslint-disable-next-line no-console
        // console.log(
        //   "No threads found for: " + state.activeFilterParams.assessmentType
        // );
        return false;
      }
      state.filterLists.threads.value.normal = currentThreads;
    },
    setCurrentSubject(state, val) {
      state.activeFilterParams.currentSubject = val;
    },
    setLearnersCurrentSubject(state) {
      //filter only by current subject
      for (let learner of state.reflectiveData) {
        if (!learner.assessmentStates) {
          continue;
        }
        // const learnerAssessments = learner.assessmentStates;
        // const learnerCatchup = learner.catchupStates;
        const totalSubjects = learner.assessmentStates.length;
        const currentAssIndex = learner.assessmentStates.findIndex(
          ass => ass.subject === state.activeFilterParams.currentSubject
        );
        //check if subject found
        if (currentAssIndex < 0 || totalSubjects === 1) {
          continue;
        }

        const currentAssessment = learner.assessmentStates.find(
          ass => ass.subject === state.activeFilterParams.currentSubject
        );
        const currentCatchupState = learner.catchupStates.find(
          catchupState => catchupState.assessmentId === currentAssessment._id
        );

        //swap assessment & catchup states to the first index
        //this assumes there are 2 subjects, more would require refactoring
        delete learner.assessmentStates;
        delete learner.catchupStates;
        // learner.assessmentStates = [learnerAssessments[currentAssIndex]];
        // const assessmentId = learnerAssessments[currentAssIndex]._id;
        // console.log('assessmentId', assessmentId);

        learner.assessmentStates = [];
        learner.catchupStates = [];

        learner.assessmentStates.push(currentAssessment);
        learner.catchupStates.push(currentCatchupState);

        // learner.catchupStates = [learnerCatchup[currentAssIndex]];
        // if (currentAssIndex === 0) {
        //   learner.assessmentStates.push(learnerAssessments[1]);
        //   learner.catchupStates.push(learnerCatchup[1]);
        // } else {
        //   learner.assessmentStates.push(learnerAssessments[0]);
        //   learner.catchupStates.push(learnerCatchup[0]);
        // }
      }
    }
  },
  actions: {
    async fetchLocales({ commit }) {
      try {
        let request = await api.get('locales');
  
        if (request.ok) {
          let response = await request.json();
          commit('setLocales', response);
          return true;
        }
        return false;
      } catch (error) {
        console.error("Error fetching locales:", error);
        return false;
      }
    },
    async fetchMyLearners({ commit, state }, school) {
      if (
        state.filterLists.schools.value &&
        state.filterLists.schools.value.length > 1
      ) {
        let request = await api.get(`dashboard?school=${school}`);

        if (request.ok) {
          let response = await request.json();
          commit("loadUsers", response);
          return true;
        }
        return false;
      } else if (
        state.filterLists.schools.value &&
        state.filterLists.schools.value.length <= 1
      ) {
        let request = await api.get(`dashboard`);

        if (request.ok) {
          let response = await request.json();
          commit("loadUsers", response);
          return true;
        }
        return false;
      }
      return false;
    },
    resetState({ commit }) {
      commit("resetState");
    },
    async fetchUsersFromProject({ commit, state }, params) {
      let request = await api.get(
        `dashboard/${params.project}${
          params.fetchBySchool ? "?school=" + params.school : ""
        }`
      );
      if (request.ok) {
        let response = await request.json();
        commit("setFetchedDataValue", params);

        const users = response.map(u => {
          return {
            _id: u._id,
            email: u.email,
            catchupStates: u.catchupStates,
            assessmentStates: u.assessmentStates
          }
        });

        commit("loadUsers", response);
        commit("loadUsersRawData", users);
        commit("setLearnersCurrentSubject");
        return true;
      }
      return false;
    },
    setupProject({ commit }, projectInfo) {
      let schools = [];
      let comms = [];

      for (let [schoolKey, schoolObject] of Object.entries(
        projectInfo.schools
      )) {
        schools.push({
          school: schoolKey,
          grades: schoolObject.dashboardFilters[0].grades,
          fetched: false,
          engagementsFetched: false,
          improvementsFetched: false
        });
        comms.push({
          school: schoolKey,
          grades: schoolObject.comms[0].grades,
          classes: schoolObject.comms[0].classes
        });
      }
      let project = {
        project: projectInfo.project,
        projectName: projectInfo.projectName,
        isMatricAssessment: projectInfo.isMatricAssessment,
        country: projectInfo.country,
        schools: [...schools],
        usersFetched: false,
        engagementsFlag: false,
        improvementsFlag: false
      };
      commit("updateProjectsArray", project);
    },
    setupCompanyProject({ commit }, companyInfo) {
      let schools = [];
      let project = {
        project: companyInfo.company,
        projectName: companyInfo.companyName,
        projectId: companyInfo.companyId,
        isMatricAssessment: false,
        schools: schools,
        tutors: companyInfo.tutors,
        usersFetched: true,
        engagementsFlag: false,
        improvementsFlag: false
      };
      commit("updateProjectsArray", project);
    },
    loadProjects({ commit, state }, allProjects) {
      state.projects = [];

      allProjects.forEach(project => {
        let schools = [];
        project.schools.forEach(school => {
          let grades = {};
          Object.keys(school.grades).forEach(gradeKey => {
            grades[gradeKey] = {
              classes: school.grades[gradeKey].classes
                ? Object.keys(school.grades[gradeKey].classes)
                : []
            };
          });
          schools.push({
            school: school.name,
            grades: grades,
            fetched: false,
            engagementsFetched: false,
            improvementsFetched: false
          });
        });
        if (project.project) {
          commit("updateProjectsArray", {
            project: project.project,
            projectName: project.projectName,
            isMatricAssessment: project.isMatricAssessment,
            schools: [...schools],
            usersFetched: false,
            engagementsFlag: false,
            improvementsFlag: false
          });
        }
      });
    },
    async updateUsers({ commit }, changes) {
      const submitThread = await api.put(`users`, {
        json: {
          changes: changes
        }
      });

      if (submitThread.status === 200) {
        // console.log("Updated users successfully");
        // Make mutation: Find user, iterate through changes, update values -> call mutation here
        changes.forEach(element => {
          commit("updateLearnersTable", element);
          commit("setLearnersCurrentSubject");
        });
        return true;
      } else {
        // console.log("Could not update users");
        return false;
      }
    },
    async archiveByEmail({ commit }, learnersEmails) {
      const archiveEmails = await api.put(`bulk-process/archive-learners`, {
        json: {
          emails: learnersEmails
        }
      });

      if (archiveEmails.status === 200) {
        commit("changeUserdata", learnersEmails);
        return true;
      } else {
        return false;
      }
    },
    async archiveLearnsFileUpload({ commit }, learners) {
      let request = await api.put("bulk-process/archive-learners", {
        json: {
          emails: learners
        }
      });

      let response = await request.text();
      if (request.ok) {
        return {
          submitted: true,
          message: "Learners were successfully archived."
        };
      } else {
        return {
          submitted: false,
          message: "Archiving failed, reason: " + response
        };
      }
    },
    async unarchiveLearnsFileUpload({ commit }, learners) {
      let request = await api.put("bulk-process/unarchive-learners", {
        json: {
          learners
        }
      });

      let response = await request.text();
      if (request.ok) {
        return {
          submitted: true,
          message: "Learners were successfully unarchived."
        };
      } else {
        return {
          submitted: false,
          message: "Unarchiving failed, reason: " + response
        };
      }
    },
    updateActiveFields({ dispatch, commit }, projectObject) {
      if (projectObject) {
        commit("updateProject", projectObject.project);
        commit("updateProjectName", projectObject.projectName);
        commit("updateCountry", projectObject.country);
        commit("updateIsMatricAssessment", projectObject.isMatricAssessment);
        dispatch("updateFilters", projectObject.project);
      }
    },
    updateSchoolId({ commit }, schoolValue) {
      commit("setSchoolIndex", schoolValue);
    },
    updateGradeId({ commit }, gradeValue) {
      commit("setGradeIndex", gradeValue);
    },
    updateCurrentSchoolName({ commit }, name) {
      commit("setCurrentSchoolName", name);
    },
    updateFilters({ commit }) {
      commit("setFilterValues");
    },
    async fetchOtherResults({ dispatch }, params) {
      await dispatch("fetchEngagementResults", params);
      await dispatch("fetchImprovementResults", params);
    },
    async fetchImprovementResults({ commit, state }, params) {
      await params.filter;
      if (state.settings.isProject) {
        let requestString = params.filter.project
          ? `project=${params.filter.project}`
          : "";
        let request = await api.get(
          `reassessment?${requestString}${
            params.fetchBySchool ? "&school=" + params.filter.school : ""
          }`
        );

        // console.log("PARAMS: ", params);
        // console.log("REQUEST: ", request);

        if (request.ok) {
          let response = await request.json();
          commit("setHasFetchedImprovements", true);
          commit("setImprovementResults", response);
          commit("setFetchedImprovementsValue", params);
        }
      }
    },
    async fetchEngagementResults({ commit, state }, params) {
      await params.filter;
      if (state.settings.isProject) {
        let requestString = params.filter.project
          ? `project=${params.filter.project}`
          : "";
        let request = await api.get(
          `engagement/learners?${requestString}${
            params.fetchBySchool ? "&school=" + params.filter.school : ""
          }`
        );
        if (request.ok) {
          let response = await request.json();
          commit("setEngagementResults", response);
          commit("setFetchedEngagementsValue", params);
        }
      }
    },

    async fetchLearnerAssessment({ commit }, userId) {
      let request = await api.get(`users/${userId}`);
      if (request.ok) {
        let response = await request.json();
        if (response.assessmentStates) {
          commit("updateActiveUser", response);
          commit("addUsers", [response]);
          return true;
        }
      }
      return false;
    },
    async fetchLearnerImprovement({ commit }, userId) {
      let request = await api.get(`reassessment/${userId}`);
      if (request.ok) {
        let response = await request.json();
        commit("setImprovementResults", response);
        return true;
      }
      return false;
    },
    async fetchLearnerEngagement({ commit }, userId) {
      let request = await api.get(`engagement/${userId}`);
      if (request.ok) {
        let response = await request.json();
        commit("setEngagementResults", response);
        return true;
      }
      return false;
    },
    async addEnglishSubject({ commit }, userId) {
      let request = await api.put(`new-assessment/english/${userId}`);
      if (request.ok) {
        let response = await request.json();
        return response;
      }
      return false;
    },
    async addMathsSubject({ commit }, userId) {
      let request = await api.put(`new-assessment/maths/${userId}`);
      if (request.ok) {
        let response = await request.json();
        return response;
      }
      return false;
    },
    async upgradeLearnerAssessments({ commit }, assessmentUpgrades) {
      const response = await api.put(`users/upgrade-learner-assessments`, {
        json: {
          assessmentUpgrades
        }
      });

      if (response.status === 200) {
        const upgradeResults = await response.json();

        commit("updateLearnersTable", upgradeResults.updatedUser);
        commit("setLearnersCurrentSubject");
        return true;
      } else {
        // console.log("Could not update users");
        return false;
      }
    },

  }
};
